import packageInfo from '../../package.json';

export const environment = {
  production: true,
  hmr: false,
  version: packageInfo.version + '-int',
  envName: 'int',
  basePath: '/home/',
  environmentName: 'INT',
  origins: ['https://aip-base-ui-int.archinsurance.io'],
  aipHostPort: 'http://aigi-irvjbss001:8080/',
  aipHostPort1: 'https://aip-base-api-int.archinsurance.io/aip-base-api/aip-base-api',
  aipHostPort2: 'https://aip-authorization-ms-int.archinsurance.io',
  aipRedirectUrl: 'http://aigi-irvjbss001.corp.archcapservices.com:8080/archweb',
  aipAdminRedirectUrl: 'https://aip-admin-ui-int.archinsurance.io',
  aipUserProfileRedirectUrl: 'https://stgmy.archinsurance.com',
  oldplportalurl: 'http://aigi-irvjbss001:8080/daspl4',
  quickClaimsUrl: 'https://claim-portal-int.archinsurance.io/claims/#/claims/report-claim',
  aipHostPortAdmin: 'https://aip-admin-api-int.archinsurance.io',
  appUrl: 'https://aip-base-ui-int.archinsurance.io/',
  AUTH_URL: 'https://archinsurance-dev.auth0.com/oauth/token',
  archConnectHost: '/', //for use with api proxy on local

  //ENV specific variables
  internalUserFlag: true,
  externalUserFlag: true,
  showDebug: true,
  SKIP_ENV_ROLE_CHECK: true,
};
